const SESSION_KEY = 'dreamteam_session_id';
const USER_ID_KEY = 'dreamteam_user_id';

export const session = {
  get: (): string | null => localStorage.getItem(SESSION_KEY),
  set: (id: string): void => localStorage.setItem(SESSION_KEY, id),
  clear: (): void => {
    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem(USER_ID_KEY);
  },
  getAuthHeaders: (): Record<string, string> => {
    const id = localStorage.getItem(SESSION_KEY);
    return id ? { Authorization: `Bearer ${id}` } : {};
  },
  getUserId: (): string | null => localStorage.getItem(USER_ID_KEY),
  setUserId: (id: string): void => localStorage.setItem(USER_ID_KEY, id),
};
